import React from 'react'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControl from '@material-ui/core/FormControl'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import { ClassValue } from 'classnames/types'
import { useMediaQuery } from 'react-responsive'
import classNames from 'classnames'
import FormControlLabelField from './FormControlLabelField'

const useStyles = makeStyles(
	(theme) => (
		{
			...styles(theme),
			formControl: {
				width: '100%',
				color: theme.palette.blue.main
			},
			radioGroupRow: {
				flexDirection: 'row'
			},
			radioGroupColumn: {
				flexDirection: 'column'
			},
			smallGroup: {
				justifyContent: 'space-between'
			},
			largeGroup: {
				'& label:not(:first-child)': {
					marginLeft: 150
				}
			}
		}
	)
)

interface RadioItem {
	label: string,
	value: string
}

interface AcceptingProps {
	items: RadioItem[],
	name: string
	value: any,
	onChange: (value: string) => void,
	textStyle: string,
	textColor: string,
	textWeight?: string,
	margin: boolean,
	rowDirection: boolean
}

type RadioFieldProps = AcceptingProps

const RadioField: React.FC<RadioFieldProps> = (
	{
		items,
		name,
		value,
		onChange,
		textStyle,
		textColor,
		textWeight,
		margin,
		rowDirection
	}
) => {
	const classes = useStyles()
	const isMobileScreen = useMediaQuery(
		{
			query: '(max-width: 500px)'
		}
	)
	const radioGroupClass: ClassValue = classNames(
		rowDirection ? classes.radioGroupRow : classes.radioGroupColumn,
		!isMobileScreen && margin && classes.largeGroup,
		isMobileScreen && classes.smallGroup
	)

	return (<FormControl component="fieldset" className={classes.formControl}>
			<RadioGroup
				aria-label={name}
				name={name}
				value={value}
				onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange((event.target as HTMLInputElement).value)}
				className={radioGroupClass}
			>
				{items.map((item: RadioItem, index: number) =>
					<FormControlLabelField
						key={`radio-${name}-${index}`}
						label={item.label}
						value={item.value}
						textStyle={textStyle}
						textColor={textColor}
						textWeight={textWeight}
					/>
				)}
			</RadioGroup>
		</FormControl>
	)
}

export default RadioField
